import { Route, Routes } from 'react-router-dom';
import { Toaster } from '../components/ui/sonner';
import StaffAppLoginPage from './pages/StaffAppLoginPage';
import StaffAppFeedPage from './pages/StaffAppFeedPage';
import StaffAppChatsPage from './pages/StaffAppChatsPage';
import StaffAppChatThreadPage from './pages/StaffAppChatThreadPage';
import StaffAppDutiPage from './pages/StaffAppDutiPage';
import StaffAppShell from './StaffAppShell';
import StaffAppToolsPage from './tools/StaffAppToolsPage';
import ProductsTool from './tools/ProductsTool';
import ProductEditPage from './tools/ProductEditPage';
import StocktakeListPage from './tools/StocktakeListPage';
import StocktakeCountPage from './tools/StocktakeCountPage';
import ReceivingListPage from './tools/ReceivingListPage';
import ReceivingCheckPage from './tools/ReceivingCheckPage';
import LeavePage from './tools/LeavePage';
import PayslipsPage from './tools/PayslipsPage';
import ExpirySweepPage from './tools/ExpirySweepPage';
import ScanToPOSPage from './tools/ScanToPOSPage';
import ScannerReviewPage from './tools/ScannerReviewPage';
import StaffAppProtectedRoute from './StaffAppProtectedRoute';
import PackOperationsPage from '../packTools/PackOperationsPage';
import PrinterProfilesPage from '../packTools/PrinterProfilesPage';
import StockInsightsPage from '../packTools/StockInsightsPage';

/** DutiLyne Staff Companion — mobile PWA. Mounted at /staff-app/* inside the
 * existing AppRouter, so it reuses the already-mounted AuthProvider /
 * SettingsProvider (same staff login, same pharmacy branding) with no
 * duplicate /auth/me or /settings fetch. */
export default function StaffAppRoutes() {
  return (
    <>
      <Toaster position="top-center" richColors />
      <Routes>
        <Route path="login" element={<StaffAppLoginPage />} />
        <Route element={<StaffAppProtectedRoute><StaffAppShell /></StaffAppProtectedRoute>}>
          <Route index element={<StaffAppFeedPage />} />
          <Route path="chats" element={<StaffAppChatsPage />} />
          <Route path="chats/:threadId" element={<StaffAppChatThreadPage />} />
          <Route path="duti" element={<StaffAppDutiPage />} />
          <Route path="tools" element={<StaffAppToolsPage />} />
          <Route path="tools/products" element={<ProductsTool />} />
          <Route path="tools/products/:productId" element={<ProductEditPage />} />
          <Route path="tools/stocktake" element={<StocktakeListPage />} />
          <Route path="tools/pack-counts" element={<PackOperationsPage />} />
          <Route path="tools/shelf-moves" element={<PackOperationsPage />} />
          <Route path="tools/printer-profiles" element={<PrinterProfilesPage />} />
          <Route path="tools/stock-insights" element={<StockInsightsPage />} />
          <Route path="tools/stocktake/:sessionId" element={<StocktakeCountPage />} />
          <Route path="tools/receiving" element={<ReceivingListPage />} />
          <Route path="tools/receiving/:poId" element={<ReceivingCheckPage />} />
          <Route path="tools/leave" element={<LeavePage />} />
          <Route path="tools/payslips" element={<PayslipsPage />} />
          <Route path="tools/expiry" element={<ExpirySweepPage />} />
          <Route path="tools/scan-pos" element={<ScanToPOSPage />} />
          <Route path="tools/scan-pos/review/:sessionId" element={<ScannerReviewPage />} />
        </Route>
      </Routes>
    </>
  );
}
